import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/anime';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Epic%20anime%20style%20landscape%20with%20silhouettes%20of%20heroes%20standing%20on%20a%20cliff%20overlooking%20a%20vast%20fantasy%20world%2C%20dramatic%20sunset%20sky%20with%20golden%20and%20coral%20clouds%2C%20cinematic%20atmosphere%2C%20professional%20anime%20art%20style%2C%20rich%20warm%20colors%2C%20grand%20scale%20composition&width=1920&height=1080&seq=hero-bg-anime&orientation=landscape"
          alt="樱花动漫网 Hero"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-background-50"></div>
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-50 mb-4 leading-tight">
          {siteConfig.name}
        </h1>
        <p className="text-base md:text-xl text-foreground-200 max-w-2xl mb-8 leading-relaxed">
          {siteConfig.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/recent"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 font-medium rounded-full text-sm transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-fire-line mr-2"></i>热门推荐
          </Link>
          <Link
            to="/category/japanese"
            className="px-8 py-3 bg-background-100/80 hover:bg-background-200/80 text-foreground-100 font-medium rounded-full text-sm border border-background-300/50 transition-all whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            <i className="ri-play-circle-line mr-2"></i>开始观看
          </Link>
        </div>
      </div>
    </section>
  );
}